import { useState } from 'react'
import SnackBarSp from './SnackBarSp'

const useSnackBar = () => {

  const [isSnackBarOpen, setSnackBarOpen] = useState(false)
  const [snackBarText, setSnackBarText] = useState('')
  const [snackBarType, setSnackBarType] = useState('info')

  const displaySnackBar = (type, text) => {
    setSnackBarText(text)
    setSnackBarType(type)
    setSnackBarOpen(true)
  }

  const renderSnackBar = () => (
    <SnackBarSp open={isSnackBarOpen} setOpen={setSnackBarOpen} text={snackBarText} type={snackBarType} />
  )

  return {
    displaySnackBar,
    renderSnackBar,
  }
}

export default useSnackBar